/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmitSessionImageModel } from '../../models/submit-session-image-model';

export interface SessionSubmitSessionImagePost$Params {
  
    /**
     * Image payload for the session
     */
    body?: SubmitSessionImageModel
}

export function sessionSubmitSessionImagePost(http: HttpClient, rootUrl: string, params?: SessionSubmitSessionImagePost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, sessionSubmitSessionImagePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as VivaLiteScanStrictHttpResponse<void>;
    })
  );
}

sessionSubmitSessionImagePost.PATH = '/Session/SubmitSessionImage';
